import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core/styles";
import clsx from "clsx";

const styles = (theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    dot: {
        width: 6,
        height: 6,
        borderRadius: 3,
        background: theme.palette.divider
    }
});

const Dots = ({className, classes, theme, dots, color, ...props}) => {
    const styleColor = theme.palette[color].main;
    const dotsArray = [];

    for (let i = 0; i < dots; i++) {
        dotsArray.push(<div key={i} className={classes.dot} style={{background: styleColor}}/>)
    }
    for (let i = dots; i < 15; i++) {
        dotsArray.push(<div key={i} className={classes.dot}/>)
    }

    return (
        <div className={clsx(classes.root, className)}>
            {dotsArray}
        </div>
    );
};

Dots.propTypes = {

};

export default withStyles(styles, {withTheme: true})(Dots);
